module.exports = __webpack_public_path__ + "static/media/onboarding-top1.99de08b3.svg";